import { GenericService } from '@/services/api/generic.service';
import { JourneyType } from '@/custom/menicon/models';

export class JourneyTypesService extends GenericService<JourneyType> {
  constructor() {
    super('/menicon/v1/journey-types');
  }
}
